<div class="container container-lg-fluid col-12 col-xl-9 mt-3 mt-lg-5 mb-5 mb-lg-0">
    <div class="col-12 d-flex justify-content-center">
        <img class="img" src="../../../assets/images/Logo_A&E_Success.png" alt="">
    </div>
    <div class="col-12 col-lg-9 mx-auto text-center mt-xs-6 mt-lg-5 pt-lg-3">
        <div class="position-relative w-fit mx-auto">
            <h1 class="fw-bold">Søknaden din er mottatt</h1>
            <img class="position-absolute double-checked-pos translate-middle" src="../../../assets/images/doble-check.svg">
        </div>

        <p class="fs-5 my-lg-5">Takk for din søknad på studie {{course}}.<br>Vi gleder oss til å behandle den. Vi har sendt en kvittering på din søknad, til<br>{{email}}.</p>
        <h2 class="fw-bold mt-5 pt-lg-5 mb-3 ">Hva skjer videre?</h2>
        <p>Vi ringer alle søkere for et hyggelig telefonmøte fra følgende telefonnummer 23 13 50 90.</p>
        <p>Du kan også lese mer på vår <a style="color: #0094ff;" href="https://akademiet.adamogeva.no/soknad/#QA" target="_blank">Spørsmål og Svar side</a> om relevant informasjon rundt studieopptak.</p>
        <button class="btn btn-primary btn-round mt-5" (click)="navigateToMainWebsite()">Gå til forsiden</button>
    </div>
</div>